
import { useTranslation } from 'react-i18next';

export default function About() {
  const { t } = useTranslation('common');

  return (
    <section id="about" className="py-12 sm:py-16 md:py-20 bg-gradient-to-b from-teal-50/30 to-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 sm:gap-12 md:gap-16 items-center">
          <div className="order-2 lg:order-1">
            <h2 className="text-xl sm:text-2xl md:text-3xl lg:text-4xl xl:text-5xl font-bold text-gray-900 mb-4 sm:mb-6">
              {t('about.title')}
            </h2>
            <p className="text-base sm:text-lg md:text-xl text-gray-600 mb-6 sm:mb-8 leading-relaxed">
              {t('about.description')}
            </p>
            
            <div className="space-y-4 sm:space-y-6">
              <div className="flex gap-3 sm:gap-4">
                <div className="w-10 h-10 sm:w-12 sm:h-12 flex items-center justify-center bg-teal-100 rounded-full flex-shrink-0">
                  <i className="ri-fish-line text-xl sm:text-2xl text-teal-600"></i>
                </div>
                <div>
                  <h3 className="text-lg sm:text-xl font-bold text-gray-900 mb-1 sm:mb-2">{t('about.freshness')}</h3>
                  <p className="text-sm sm:text-base text-gray-600">{t('about.freshnessDesc')}</p>
                </div>
              </div>

              <div className="flex gap-3 sm:gap-4">
                <div className="w-10 h-10 sm:w-12 sm:h-12 flex items-center justify-center bg-teal-100 rounded-full flex-shrink-0">
                  <i className="ri-shield-check-line text-xl sm:text-2xl text-teal-600"></i>
                </div>
                <div>
                  <h3 className="text-lg sm:text-xl font-bold text-gray-900 mb-1 sm:mb-2">{t('about.quality')}</h3>
                  <p className="text-sm sm:text-base text-gray-600">{t('about.qualityDesc')}</p>
                </div>
              </div>

              <div className="flex gap-3 sm:gap-4">
                <div className="w-10 h-10 sm:w-12 sm:h-12 flex items-center justify-center bg-teal-100 rounded-full flex-shrink-0">
                  <i className="ri-truck-line text-xl sm:text-2xl text-teal-600"></i>
                </div>
                <div>
                  <h3 className="text-lg sm:text-xl font-bold text-gray-900 mb-1 sm:mb-2">{t('about.delivery')}</h3>
                  <p className="text-sm sm:text-base text-gray-600">{t('about.deliveryDesc')}</p>
                </div>
              </div>

              <div className="flex gap-3 sm:gap-4">
                <div className="w-10 h-10 sm:w-12 sm:h-12 flex items-center justify-center bg-teal-100 rounded-full flex-shrink-0">
                  <i className="ri-restaurant-line text-xl sm:text-2xl text-teal-600"></i>
                </div>
                <div>
                  <h3 className="text-lg sm:text-xl font-bold text-gray-900 mb-1 sm:mb-2">{t('about.traditional')}</h3>
                  <p className="text-sm sm:text-base text-gray-600">{t('about.traditionalDesc')}</p>
                </div>
              </div>
            </div>

            <div className="mt-8 sm:mt-10 p-4 sm:p-6 bg-amber-50 border-l-4 border-amber-500 rounded-lg">
              <h3 className="text-base sm:text-lg md:text-xl font-bold text-gray-900 mb-3 flex items-center gap-2">
                <i className="ri-information-line text-amber-600"></i>
                {t('about.salesConditions')}
              </h3>
              <div className="space-y-2 text-sm sm:text-base text-gray-700">
                <p className="flex items-start gap-2">
                  <i className="ri-checkbox-circle-fill text-amber-600 mt-1 flex-shrink-0"></i>
                  <span>{t('about.condition1')}</span>
                </p>
                <p className="flex items-start gap-2">
                  <i className="ri-checkbox-circle-fill text-amber-600 mt-1 flex-shrink-0"></i>
                  <span>{t('about.condition2')}</span>
                </p>
              </div>
            </div>
          </div>

          <div className="order-1 lg:order-2">
            <img 
              src="https://static.readdy.ai/image/a808dc7181425b7ee1ae1c223286d53e/cb6f13d59fa3b122e1a656ba74b7f99b.jpeg"
              alt="Notre équipe et nos produits"
              className="w-full h-auto rounded-2xl shadow-2xl"
            />
          </div>
        </div>
      </div>
    </section>
  );
}
